import { QSetStatus } from '@exam-management/graphql';
import { useParams } from '@exam-management/router';

import { useQSetListSearchParams } from '../../hooks';
import { PublishedQSetListModalProvider } from '../../providers';
import { DisabledQSetList } from '../disabled-qset-list';
import { DraftQSetList } from '../draft-qset-list';
import { DraftQSetListBanner } from '../draft-qset-list-banner';
import { InReviewQSetList } from '../in-review-qset-list';
import { InReviewQSetListBanner } from '../in-review-qset-list-banner';
import { PublishedQSetList } from '../published-qset-list';
import { PublishedQSetListBanner } from '../published-qset-list-banner';
import { ReviewedQSetList } from '../reviewed-qset-list';
import { ReviewedQSetListBanner } from '../reviewed-qset-list-banner';

export default function QSetList() {
  const { courseId } = useParams('/exam-courses/:courseId/qsets');
  const [{ status }] = useQSetListSearchParams();

  switch (status) {
    case QSetStatus.Draft:
      return (
        <>
          <DraftQSetListBanner />
          <DraftQSetList />
        </>
      );
    case QSetStatus.InReview:
      return (
        <>
          <InReviewQSetListBanner />
          <InReviewQSetList />
        </>
      );
    case QSetStatus.Reviewed:
      return (
        <>
          <ReviewedQSetListBanner />
          <ReviewedQSetList />
        </>
      );
    case QSetStatus.Published:
      return (
        <PublishedQSetListModalProvider courseId={courseId}>
          <PublishedQSetListBanner />
          <PublishedQSetList />
        </PublishedQSetListModalProvider>
      );
    case QSetStatus.Unpublished:
      return 'wait for implementation of UnpublishedQSetList';
    case QSetStatus.Disabled:
      return <DisabledQSetList />;
    default:
      return null;
  }
}
